import { useState, useEffect } from 'react';
import CTEyeService from '../../../services/CTEyeService';
import { GaugeConfig } from '../../../data/entities';

export function useGaugeConfig(clientId: string): GaugeConfig | null {
  const [gaugeConfig, setGaugeConfig] = useState<GaugeConfig | null>(null);

  useEffect(() => {
    new CTEyeService()
      .getClientGaugeConfig(clientId)
      .then(setGaugeConfig)
      .catch(err => console.error('Error loading gauge config:', err));
  }, [clientId]);

  return gaugeConfig;
}
